'use strict';

const $ = require('jquery');
const _ = require('underscore');
const Mn = require('backbone.marionette');
const Route = require('common/route');
const TypeaheadView = require('common/ui/view/typeahead');
const ElementAction = require('system/domain/action/element');
const DiagramRepository = require('system/domain/repository/diagram');
const NodeModel = require('system/domain/entity/node');
const AddSymbolicNodeModalTemplate = require('system/ui/template/modal/add-symbolic-node.hbs');
const SearchboxItemTemplate = require('system/ui/template/detail/searchbox-dropdown-item.hbs');

/**
 * Symbolic Node 関連の Module
 */
module.exports = Mn.View.extend({
    template: AddSymbolicNodeModalTemplate,
    ui: {
        searchNode: '.search-node',
        modal: '.modal'
    },

    initialize: function() {
        _.bindAll(this, 'show');
    },

    onRender: function() {
        const diagram = this.getOption('diagram');
        const context = this.getOption('context');
        const channel = this.getOption('channel');

        new TypeaheadView({
            minLength: 1,
            el: this.ui.searchNode,
            find: function(query) {
                const deferred = $.Deferred();
                const path = Route.urlFor(
                    'api:project:search', diagram.toJSON());
                $.ajax({
                    url: `${path}?query=Record:name=${query}`,
                    dataType: 'json'
                }).done(function(data) {
                    deferred.resolve(_.chain(data['Record'])
                        .map(function(d){
                                return new NodeModel(d);
                            }
                        )
                        .filter(function(n) {
                            return !diagram.hasNode(n);
                        })
                        .value()
                    );
                });
                return deferred.done;
            },

            update: _.bind(function(node) {
                const pos = channel.request('canvas:center');
                const meta = {
                    id: node.id,
                    x: pos.x,
                    y: pos.y,
                    creating: true
                };
                ElementAction.createSymbolicNode({
                    context: context,
                    nodeMeta: meta,
                    node: node.toJSON()
                });
                this.hide();
                return '';
            }, this),

            enter: _.bind(function(query) {
                return query;
            }, this),

            itemView: TypeaheadView.DropdownItemView.extend({
                template: SearchboxItemTemplate,
                render: function() {
                    const model = this.model;
                    const j = this.model.toJSON();
                    j.diagrams = DiagramRepository.getDiagrams({
                        context: context
                    })
                        .chain()
                        .filter(function(d) {
                            return d.hasElement(model);
                        })
                        .map(function(d){
                            return d.toJSON();
                        })
                        .value();
                    this.$el.html(this.template(j));
                    return this;
                }
            })
        });
    },

    show: function() {
        this.ui.modal.modal({
            show: true,
            backdrop: false
        });
        this.ui.modal.on('shown.bs.modal', _.bind(function() {
            this.ui.searchNode.focus();
        }, this));
    },

    hide: function() {
        this.ui.modal.modal('hide');
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/modal/symbolic-node-add.js